'use strict';

var cov_23osts6k1z = function () {
  var path = 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\index.js',
      hash = 'de6abc30364e9e70634cdfc3ddfad8ebd9bd6cf3',
      global = new Function('return this')(),
      gcv = '__coverage__',
      coverageData = {
    path: 'D:\\freelance\\phongthuy-vina\\phongthuy_frontend\\src\\index.js',
    statementMap: {
      '0': {
        start: {
          line: 1,
          column: 0
        },
        end: {
          line: 394,
          column: 6
        }
      },
      '1': {
        start: {
          line: 19,
          column: 6
        },
        end: {
          line: 19,
          column: 111
        }
      },
      '2': {
        start: {
          line: 21,
          column: 4
        },
        end: {
          line: 21,
          column: 27
        }
      },
      '3': {
        start: {
          line: 23,
          column: 37
        },
        end: {
          line: 23,
          column: 61
        }
      },
      '4': {
        start: {
          line: 25,
          column: 4
        },
        end: {
          line: 53,
          column: 6
        }
      },
      '5': {
        start: {
          line: 32,
          column: 8
        },
        end: {
          line: 44,
          column: 43
        }
      },
      '6': {
        start: {
          line: 47,
          column: 8
        },
        end: {
          line: 47,
          column: 36
        }
      },
      '7': {
        start: {
          line: 48,
          column: 8
        },
        end: {
          line: 48,
          column: 34
        }
      },
      '8': {
        start: {
          line: 49,
          column: 8
        },
        end: {
          line: 51,
          column: 9
        }
      },
      '9': {
        start: {
          line: 50,
          column: 10
        },
        end: {
          line: 50,
          column: 35
        }
      },
      '10': {
        start: {
          line: 56,
          column: 4
        },
        end: {
          line: 104,
          column: 6
        }
      },
      '11': {
        start: {
          line: 63,
          column: 8
        },
        end: {
          line: 95,
          column: 10
        }
      },
      '12': {
        start: {
          line: 98,
          column: 8
        },
        end: {
          line: 98,
          column: 36
        }
      },
      '13': {
        start: {
          line: 99,
          column: 8
        },
        end: {
          line: 99,
          column: 34
        }
      },
      '14': {
        start: {
          line: 100,
          column: 8
        },
        end: {
          line: 102,
          column: 9
        }
      },
      '15': {
        start: {
          line: 101,
          column: 10
        },
        end: {
          line: 101,
          column: 35
        }
      },
      '16': {
        start: {
          line: 107,
          column: 4
        },
        end: {
          line: 138,
          column: 6
        }
      },
      '17': {
        start: {
          line: 115,
          column: 8
        },
        end: {
          line: 115,
          column: 37
        }
      },
      '18': {
        start: {
          line: 116,
          column: 8
        },
        end: {
          line: 116,
          column: 35
        }
      },
      '19': {
        start: {
          line: 117,
          column: 8
        },
        end: {
          line: 117,
          column: 51
        }
      },
      '20': {
        start: {
          line: 119,
          column: 8
        },
        end: {
          line: 136,
          column: 11
        }
      },
      '21': {
        start: {
          line: 120,
          column: 10
        },
        end: {
          line: 135,
          column: 11
        }
      },
      '22': {
        start: {
          line: 121,
          column: 12
        },
        end: {
          line: 121,
          column: 64
        }
      },
      '23': {
        start: {
          line: 124,
          column: 20
        },
        end: {
          line: 124,
          column: 46
        }
      },
      '24': {
        start: {
          line: 125,
          column: 12
        },
        end: {
          line: 125,
          column: 41
        }
      },
      '25': {
        start: {
          line: 125,
          column: 34
        },
        end: {
          line: 125,
          column: 41
        }
      },
      '26': {
        start: {
          line: 126,
          column: 12
        },
        end: {
          line: 126,
          column: 78
        }
      },
      '27': {
        start: {
          line: 126,
          column: 71
        },
        end: {
          line: 126,
          column: 78
        }
      },
      '28': {
        start: {
          line: 127,
          column: 12
        },
        end: {
          line: 127,
          column: 62
        }
      },
      '29': {
        start: {
          line: 127,
          column: 55
        },
        end: {
          line: 127,
          column: 62
        }
      },
      '30': {
        start: {
          line: 128,
          column: 12
        },
        end: {
          line: 130,
          column: 13
        }
      },
      '31': {
        start: {
          line: 129,
          column: 14
        },
        end: {
          line: 129,
          column: 40
        }
      },
      '32': {
        start: {
          line: 131,
          column: 22
        },
        end: {
          line: 131,
          column: 48
        }
      },
      '33': {
        start: {
          line: 132,
          column: 12
        },
        end: {
          line: 134,
          column: 13
        }
      },
      '34': {
        start: {
          line: 133,
          column: 14
        },
        end: {
          line: 133,
          column: 40
        }
      },
      '35': {
        start: {
          line: 141,
          column: 4
        },
        end: {
          line: 160,
          column: 6
        }
      },
      '36': {
        start: {
          line: 148,
          column: 8
        },
        end: {
          line: 151,
          column: 10
        }
      },
      '37': {
        start: {
          line: 154,
          column: 8
        },
        end: {
          line: 154,
          column: 36
        }
      },
      '38': {
        start: {
          line: 155,
          column: 8
        },
        end: {
          line: 155,
          column: 34
        }
      },
      '39': {
        start: {
          line: 156,
          column: 8
        },
        end: {
          line: 158,
          column: 9
        }
      },
      '40': {
        start: {
          line: 157,
          column: 10
        },
        end: {
          line: 157,
          column: 35
        }
      },
      '41': {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 182,
          column: 6
        }
      },
      '42': {
        start: {
          line: 170,
          column: 8
        },
        end: {
          line: 173,
          column: 10
        }
      },
      '43': {
        start: {
          line: 176,
          column: 8
        },
        end: {
          line: 176,
          column: 36
        }
      },
      '44': {
        start: {
          line: 177,
          column: 8
        },
        end: {
          line: 177,
          column: 34
        }
      },
      '45': {
        start: {
          line: 178,
          column: 8
        },
        end: {
          line: 180,
          column: 9
        }
      },
      '46': {
        start: {
          line: 179,
          column: 10
        },
        end: {
          line: 179,
          column: 35
        }
      },
      '47': {
        start: {
          line: 185,
          column: 4
        },
        end: {
          line: 262,
          column: 6
        }
      },
      '48': {
        start: {
          line: 192,
          column: 8
        },
        end: {
          line: 253,
          column: 10
        }
      },
      '49': {
        start: {
          line: 256,
          column: 8
        },
        end: {
          line: 256,
          column: 36
        }
      },
      '50': {
        start: {
          line: 257,
          column: 8
        },
        end: {
          line: 257,
          column: 34
        }
      },
      '51': {
        start: {
          line: 258,
          column: 8
        },
        end: {
          line: 260,
          column: 9
        }
      },
      '52': {
        start: {
          line: 259,
          column: 10
        },
        end: {
          line: 259,
          column: 35
        }
      },
      '53': {
        start: {
          line: 265,
          column: 4
        },
        end: {
          line: 306,
          column: 6
        }
      },
      '54': {
        start: {
          line: 272,
          column: 8
        },
        end: {
          line: 297,
          column: 10
        }
      },
      '55': {
        start: {
          line: 300,
          column: 8
        },
        end: {
          line: 300,
          column: 36
        }
      },
      '56': {
        start: {
          line: 301,
          column: 8
        },
        end: {
          line: 301,
          column: 34
        }
      },
      '57': {
        start: {
          line: 302,
          column: 8
        },
        end: {
          line: 304,
          column: 9
        }
      },
      '58': {
        start: {
          line: 303,
          column: 10
        },
        end: {
          line: 303,
          column: 35
        }
      },
      '59': {
        start: {
          line: 309,
          column: 4
        },
        end: {
          line: 364,
          column: 6
        }
      },
      '60': {
        start: {
          line: 310,
          column: 6
        },
        end: {
          line: 312,
          column: 7
        }
      },
      '61': {
        start: {
          line: 311,
          column: 8
        },
        end: {
          line: 311,
          column: 15
        }
      },
      '62': {
        start: {
          line: 314,
          column: 6
        },
        end: {
          line: 314,
          column: 18
        }
      },
      '63': {
        start: {
          line: 315,
          column: 6
        },
        end: {
          line: 315,
          column: 30
        }
      },
      '64': {
        start: {
          line: 316,
          column: 6
        },
        end: {
          line: 316,
          column: 67
        }
      },
      '65': {
        start: {
          line: 317,
          column: 6
        },
        end: {
          line: 317,
          column: 55
        }
      },
      '66': {
        start: {
          line: 318,
          column: 6
        },
        end: {
          line: 318,
          column: 43
        }
      },
      '67': {
        start: {
          line: 319,
          column: 6
        },
        end: {
          line: 319,
          column: 67
        }
      },
      '68': {
        start: {
          line: 320,
          column: 6
        },
        end: {
          line: 320,
          column: 55
        }
      },
      '69': {
        start: {
          line: 321,
          column: 6
        },
        end: {
          line: 321,
          column: 43
        }
      },
      '70': {
        start: {
          line: 322,
          column: 6
        },
        end: {
          line: 322,
          column: 35
        }
      },
      '71': {
        start: {
          line: 326,
          column: 6
        },
        end: {
          line: 326,
          column: 115
        }
      },
      '72': {
        start: {
          line: 327,
          column: 6
        },
        end: {
          line: 327,
          column: 16
        }
      },
      '73': {
        start: {
          line: 367,
          column: 4
        },
        end: {
          line: 367,
          column: 52
        }
      },
      '74': {
        start: {
          line: 368,
          column: 4
        },
        end: {
          line: 393,
          column: 6
        }
      },
      '75': {
        start: {
          line: 370,
          column: 8
        },
        end: {
          line: 387,
          column: 9
        }
      },
      '76': {
        start: {
          line: 371,
          column: 22
        },
        end: {
          line: 371,
          column: 61
        }
      },
      '77': {
        start: {
          line: 372,
          column: 10
        },
        end: {
          line: 386,
          column: 11
        }
      },
      '78': {
        start: {
          line: 373,
          column: 23
        },
        end: {
          line: 373,
          column: 56
        }
      },
      '79': {
        start: {
          line: 374,
          column: 27
        },
        end: {
          line: 374,
          column: 104
        }
      },
      '80': {
        start: {
          line: 376,
          column: 26
        },
        end: {
          line: 376,
          column: 89
        }
      },
      '81': {
        start: {
          line: 377,
          column: 12
        },
        end: {
          line: 382,
          column: 13
        }
      },
      '82': {
        start: {
          line: 378,
          column: 14
        },
        end: {
          line: 378,
          column: 58
        }
      },
      '83': {
        start: {
          line: 380,
          column: 14
        },
        end: {
          line: 380,
          column: 52
        }
      },
      '84': {
        start: {
          line: 381,
          column: 14
        },
        end: {
          line: 381,
          column: 89
        }
      },
      '85': {
        start: {
          line: 384,
          column: 12
        },
        end: {
          line: 384,
          column: 56
        }
      },
      '86': {
        start: {
          line: 385,
          column: 12
        },
        end: {
          line: 385,
          column: 87
        }
      },
      '87': {
        start: {
          line: 390,
          column: 8
        },
        end: {
          line: 390,
          column: 50
        }
      },
      '88': {
        start: {
          line: 395,
          column: 16
        },
        end: {
          line: 395,
          column: 53
        }
      },
      '89': {
        start: {
          line: 396,
          column: 0
        },
        end: {
          line: 398,
          column: 3
        }
      },
      '90': {
        start: {
          line: 397,
          column: 2
        },
        end: {
          line: 397,
          column: 59
        }
      },
      '91': {
        start: {
          line: 399,
          column: 0
        },
        end: {
          line: 401,
          column: 3
        }
      },
      '92': {
        start: {
          line: 400,
          column: 2
        },
        end: {
          line: 400,
          column: 47
        }
      },
      '93': {
        start: {
          line: 402,
          column: 0
        },
        end: {
          line: 413,
          column: 3
        }
      },
      '94': {
        start: {
          line: 403,
          column: 2
        },
        end: {
          line: 403,
          column: 42
        }
      },
      '95': {
        start: {
          line: 404,
          column: 2
        },
        end: {
          line: 404,
          column: 55
        }
      },
      '96': {
        start: {
          line: 405,
          column: 2
        },
        end: {
          line: 405,
          column: 70
        }
      },
      '97': {
        start: {
          line: 406,
          column: 2
        },
        end: {
          line: 406,
          column: 56
        }
      },
      '98': {
        start: {
          line: 407,
          column: 2
        },
        end: {
          line: 407,
          column: 29
        }
      },
      '99': {
        start: {
          line: 408,
          column: 2
        },
        end: {
          line: 408,
          column: 29
        }
      },
      '100': {
        start: {
          line: 409,
          column: 2
        },
        end: {
          line: 412,
          column: 3
        }
      },
      '101': {
        start: {
          line: 410,
          column: 4
        },
        end: {
          line: 410,
          column: 61
        }
      },
      '102': {
        start: {
          line: 414,
          column: 0
        },
        end: {
          line: 416,
          column: 3
        }
      },
      '103': {
        start: {
          line: 415,
          column: 2
        },
        end: {
          line: 415,
          column: 59
        }
      },
      '104': {
        start: {
          line: 417,
          column: 0
        },
        end: {
          line: 419,
          column: 3
        }
      },
      '105': {
        start: {
          line: 418,
          column: 2
        },
        end: {
          line: 418,
          column: 47
        }
      }
    },
    fnMap: {
      '0': {
        name: '(anonymous_0)',
        decl: {
          start: {
            line: 17,
            column: 24
          },
          end: {
            line: 17,
            column: 25
          }
        },
        loc: {
          start: {
            line: 17,
            column: 36
          },
          end: {
            line: 22,
            column: 3
          }
        },
        line: 17
      },
      '1': {
        name: 'prettyPrintJson',
        decl: {
          start: {
            line: 18,
            column: 13
          },
          end: {
            line: 18,
            column: 28
          }
        },
        loc: {
          start: {
            line: 18,
            column: 35
          },
          end: {
            line: 20,
            column: 5
          }
        },
        line: 18
      },
      '2': {
        name: '(anonymous_2)',
        decl: {
          start: {
            line: 23,
            column: 20
          },
          end: {
            line: 23,
            column: 21
          }
        },
        loc: {
          start: {
            line: 23,
            column: 35
          },
          end: {
            line: 23,
            column: 63
          }
        },
        line: 23
      },
      '3': {
        name: '(anonymous_3)',
        decl: {
          start: {
            line: 24,
            column: 30
          },
          end: {
            line: 24,
            column: 31
          }
        },
        loc: {
          start: {
            line: 24,
            column: 42
          },
          end: {
            line: 54,
            column: 3
          }
        },
        line: 24
      },
      '4': {
        name: '(anonymous_4)',
        decl: {
          start: {
            line: 31,
            column: 18
          },
          end: {
            line: 31,
            column: 19
          }
        },
        loc: {
          start: {
            line: 31,
            column: 36
          },
          end: {
            line: 45,
            column: 7
          }
        },
        line: 31
      },
      '5': {
        name: '(anonymous_5)',
        decl: {
          start: {
            line: 46,
            column: 12
          },
          end: {
            line: 46,
            column: 13
          }
        },
        loc: {
          start: {
            line: 46,
            column: 56
          },
          end: {
            line: 52,
            column: 7
          }
        },
        line: 46
      },
      '6': {
        name: '(anonymous_6)',
        decl: {
          start: {
            line: 55,
            column: 28
          },
          end: {
            line: 55,
            column: 29
          }
        },
        loc: {
          start: {
            line: 55,
            column: 40
          },
          end: {
            line: 105,
            column: 3
          }
        },
        line: 55
      },
      '7': {
        name: '(anonymous_7)',
        decl: {
          start: {
            line: 62,
            column: 18
          },
          end: {
            line: 62,
            column: 19
          }
        },
        loc: {
          start: {
            line: 62,
            column: 36
          },
          end: {
            line: 96,
            column: 7
          }
        },
        line: 62
      },
      '8': {
        name: '(anonymous_8)',
        decl: {
          start: {
            line: 97,
            column: 12
          },
          end: {
            line: 97,
            column: 13
          }
        },
        loc: {
          start: {
            line: 97,
            column: 56
          },
          end: {
            line: 103,
            column: 7
          }
        },
        line: 97
      },
      '9': {
        name: '(anonymous_9)',
        decl: {
          start: {
            line: 106,
            column: 29
          },
          end: {
            line: 106,
            column: 30
          }
        },
        loc: {
          start: {
            line: 106,
            column: 41
          },
          end: {
            line: 139,
            column: 3
          }
        },
        line: 106
      },
      '10': {
        name: '(anonymous_10)',
        decl: {
          start: {
            line: 114,
            column: 12
          },
          end: {
            line: 114,
            column: 13
          }
        },
        loc: {
          start: {
            line: 114,
            column: 55
          },
          end: {
            line: 137,
            column: 7
          }
        },
        line: 114
      },
      '11': {
        name: '(anonymous_11)',
        decl: {
          start: {
            line: 119,
            column: 33
          },
          end: {
            line: 119,
            column: 34
          }
        },
        loc: {
          start: {
            line: 119,
            column: 63
          },
          end: {
            line: 136,
            column: 9
          }
        },
        line: 119
      },
      '12': {
        name: '(anonymous_12)',
        decl: {
          start: {
            line: 140,
            column: 23
          },
          end: {
            line: 140,
            column: 24
          }
        },
        loc: {
          start: {
            line: 140,
            column: 35
          },
          end: {
            line: 161,
            column: 3
          }
        },
        line: 140
      },
      '13': {
        name: '(anonymous_13)',
        decl: {
          start: {
            line: 147,
            column: 18
          },
          end: {
            line: 147,
            column: 19
          }
        },
        loc: {
          start: {
            line: 147,
            column: 36
          },
          end: {
            line: 152,
            column: 7
          }
        },
        line: 147
      },
      '14': {
        name: '(anonymous_14)',
        decl: {
          start: {
            line: 153,
            column: 12
          },
          end: {
            line: 153,
            column: 13
          }
        },
        loc: {
          start: {
            line: 153,
            column: 56
          },
          end: {
            line: 159,
            column: 7
          }
        },
        line: 153
      },
      '15': {
        name: '(anonymous_15)',
        decl: {
          start: {
            line: 162,
            column: 28
          },
          end: {
            line: 162,
            column: 29
          }
        },
        loc: {
          start: {
            line: 162,
            column: 40
          },
          end: {
            line: 183,
            column: 3
          }
        },
        line: 162
      },
      '16': {
        name: '(anonymous_16)',
        decl: {
          start: {
            line: 169,
            column: 18
          },
          end: {
            line: 169,
            column: 19
          }
        },
        loc: {
          start: {
            line: 169,
            column: 36
          },
          end: {
            line: 174,
            column: 7
          }
        },
        line: 169
      },
      '17': {
        name: '(anonymous_17)',
        decl: {
          start: {
            line: 175,
            column: 12
          },
          end: {
            line: 175,
            column: 13
          }
        },
        loc: {
          start: {
            line: 175,
            column: 56
          },
          end: {
            line: 181,
            column: 7
          }
        },
        line: 175
      },
      '18': {
        name: '(anonymous_18)',
        decl: {
          start: {
            line: 184,
            column: 26
          },
          end: {
            line: 184,
            column: 27
          }
        },
        loc: {
          start: {
            line: 184,
            column: 38
          },
          end: {
            line: 263,
            column: 3
          }
        },
        line: 184
      },
      '19': {
        name: '(anonymous_19)',
        decl: {
          start: {
            line: 191,
            column: 18
          },
          end: {
            line: 191,
            column: 19
          }
        },
        loc: {
          start: {
            line: 191,
            column: 36
          },
          end: {
            line: 254,
            column: 7
          }
        },
        line: 191
      },
      '20': {
        name: '(anonymous_20)',
        decl: {
          start: {
            line: 255,
            column: 12
          },
          end: {
            line: 255,
            column: 13
          }
        },
        loc: {
          start: {
            line: 255,
            column: 56
          },
          end: {
            line: 261,
            column: 7
          }
        },
        line: 255
      },
      '21': {
        name: '(anonymous_21)',
        decl: {
          start: {
            line: 264,
            column: 24
          },
          end: {
            line: 264,
            column: 25
          }
        },
        loc: {
          start: {
            line: 264,
            column: 36
          },
          end: {
            line: 307,
            column: 3
          }
        },
        line: 264
      },
      '22': {
        name: '(anonymous_22)',
        decl: {
          start: {
            line: 271,
            column: 18
          },
          end: {
            line: 271,
            column: 19
          }
        },
        loc: {
          start: {
            line: 271,
            column: 36
          },
          end: {
            line: 298,
            column: 7
          }
        },
        line: 271
      },
      '23': {
        name: '(anonymous_23)',
        decl: {
          start: {
            line: 299,
            column: 12
          },
          end: {
            line: 299,
            column: 13
          }
        },
        loc: {
          start: {
            line: 299,
            column: 56
          },
          end: {
            line: 305,
            column: 7
          }
        },
        line: 299
      },
      '24': {
        name: '(anonymous_24)',
        decl: {
          start: {
            line: 308,
            column: 24
          },
          end: {
            line: 308,
            column: 25
          }
        },
        loc: {
          start: {
            line: 308,
            column: 35
          },
          end: {
            line: 365,
            column: 3
          }
        },
        line: 308
      },
      '25': {
        name: '(anonymous_25)',
        decl: {
          start: {
            line: 309,
            column: 11
          },
          end: {
            line: 309,
            column: 12
          }
        },
        loc: {
          start: {
            line: 309,
            column: 27
          },
          end: {
            line: 364,
            column: 5
          }
        },
        line: 309
      },
      '26': {
        name: '(anonymous_26)',
        decl: {
          start: {
            line: 366,
            column: 59
          },
          end: {
            line: 366,
            column: 60
          }
        },
        loc: {
          start: {
            line: 366,
            column: 99
          },
          end: {
            line: 394,
            column: 3
          }
        },
        line: 366
      },
      '27': {
        name: '(anonymous_27)',
        decl: {
          start: {
            line: 396,
            column: 40
          },
          end: {
            line: 396,
            column: 41
          }
        },
        loc: {
          start: {
            line: 396,
            column: 52
          },
          end: {
            line: 398,
            column: 1
          }
        },
        line: 396
      },
      '28': {
        name: '(anonymous_28)',
        decl: {
          start: {
            line: 399,
            column: 52
          },
          end: {
            line: 399,
            column: 53
          }
        },
        loc: {
          start: {
            line: 399,
            column: 64
          },
          end: {
            line: 401,
            column: 1
          }
        },
        line: 399
      },
      '29': {
        name: '(anonymous_29)',
        decl: {
          start: {
            line: 402,
            column: 51
          },
          end: {
            line: 402,
            column: 52
          }
        },
        loc: {
          start: {
            line: 402,
            column: 63
          },
          end: {
            line: 413,
            column: 1
          }
        },
        line: 402
      },
      '30': {
        name: '(anonymous_30)',
        decl: {
          start: {
            line: 414,
            column: 40
          },
          end: {
            line: 414,
            column: 41
          }
        },
        loc: {
          start: {
            line: 414,
            column: 52
          },
          end: {
            line: 416,
            column: 1
          }
        },
        line: 414
      },
      '31': {
        name: '(anonymous_31)',
        decl: {
          start: {
            line: 417,
            column: 52
          },
          end: {
            line: 417,
            column: 53
          }
        },
        loc: {
          start: {
            line: 417,
            column: 64
          },
          end: {
            line: 419,
            column: 1
          }
        },
        line: 417
      }
    },
    branchMap: {
      '0': {
        loc: {
          start: {
            line: 19,
            column: 13
          },
          end: {
            line: 19,
            column: 110
          }
        },
        type: 'cond-expr',
        locations: [{
          start: {
            line: 19,
            column: 20
          },
          end: {
            line: 19,
            column: 52
          }
        }, {
          start: {
            line: 19,
            column: 55
          },
          end: {
            line: 19,
            column: 110
          }
        }],
        line: 19
      },
      '1': {
        loc: {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }, {
          start: {
            line: 49,
            column: 8
          },
          end: {
            line: 51,
            column: 9
          }
        }],
        line: 49
      },
      '2': {
        loc: {
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 102,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 102,
            column: 9
          }
        }, {
          start: {
            line: 100,
            column: 8
          },
          end: {
            line: 102,
            column: 9
          }
        }],
        line: 100
      },
      '3': {
        loc: {
          start: {
            line: 120,
            column: 10
          },
          end: {
            line: 135,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 120,
            column: 10
          },
          end: {
            line: 135,
            column: 11
          }
        }, {
          start: {
            line: 120,
            column: 10
          },
          end: {
            line: 135,
            column: 11
          }
        }],
        line: 120
      },
      '4': {
        loc: {
          start: {
            line: 125,
            column: 12
          },
          end: {
            line: 125,
            column: 41
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 125,
            column: 12
          },
          end: {
            line: 125,
            column: 41
          }
        }, {
          start: {
            line: 125,
            column: 12
          },
          end: {
            line: 125,
            column: 41
          }
        }],
        line: 125
      },
      '5': {
        loc: {
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 78
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 78
          }
        }, {
          start: {
            line: 126,
            column: 12
          },
          end: {
            line: 126,
            column: 78
          }
        }],
        line: 126
      },
      '6': {
        loc: {
          start: {
            line: 126,
            column: 16
          },
          end: {
            line: 126,
            column: 69
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 126,
            column: 16
          },
          end: {
            line: 126,
            column: 32
          }
        }, {
          start: {
            line: 126,
            column: 37
          },
          end: {
            line: 126,
            column: 50
          }
        }, {
          start: {
            line: 126,
            column: 54
          },
          end: {
            line: 126,
            column: 68
          }
        }],
        line: 126
      },
      '7': {
        loc: {
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 62
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 62
          }
        }, {
          start: {
            line: 127,
            column: 12
          },
          end: {
            line: 127,
            column: 62
          }
        }],
        line: 127
      },
      '8': {
        loc: {
          start: {
            line: 127,
            column: 16
          },
          end: {
            line: 127,
            column: 53
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 127,
            column: 16
          },
          end: {
            line: 127,
            column: 32
          }
        }, {
          start: {
            line: 127,
            column: 36
          },
          end: {
            line: 127,
            column: 53
          }
        }],
        line: 127
      },
      '9': {
        loc: {
          start: {
            line: 128,
            column: 12
          },
          end: {
            line: 130,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 128,
            column: 12
          },
          end: {
            line: 130,
            column: 13
          }
        }, {
          start: {
            line: 128,
            column: 12
          },
          end: {
            line: 130,
            column: 13
          }
        }],
        line: 128
      },
      '10': {
        loc: {
          start: {
            line: 128,
            column: 16
          },
          end: {
            line: 128,
            column: 129
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 128,
            column: 16
          },
          end: {
            line: 128,
            column: 31
          }
        }, {
          start: {
            line: 128,
            column: 36
          },
          end: {
            line: 128,
            column: 85
          }
        }, {
          start: {
            line: 128,
            column: 89
          },
          end: {
            line: 128,
            column: 128
          }
        }],
        line: 128
      },
      '11': {
        loc: {
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 134,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 134,
            column: 13
          }
        }, {
          start: {
            line: 132,
            column: 12
          },
          end: {
            line: 134,
            column: 13
          }
        }],
        line: 132
      },
      '12': {
        loc: {
          start: {
            line: 132,
            column: 16
          },
          end: {
            line: 132,
            column: 37
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 132,
            column: 16
          },
          end: {
            line: 132,
            column: 23
          }
        }, {
          start: {
            line: 132,
            column: 27
          },
          end: {
            line: 132,
            column: 37
          }
        }],
        line: 132
      },
      '13': {
        loc: {
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        }, {
          start: {
            line: 156,
            column: 8
          },
          end: {
            line: 158,
            column: 9
          }
        }],
        line: 156
      },
      '14': {
        loc: {
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 180,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 180,
            column: 9
          }
        }, {
          start: {
            line: 178,
            column: 8
          },
          end: {
            line: 180,
            column: 9
          }
        }],
        line: 178
      },
      '15': {
        loc: {
          start: {
            line: 258,
            column: 8
          },
          end: {
            line: 260,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 258,
            column: 8
          },
          end: {
            line: 260,
            column: 9
          }
        }, {
          start: {
            line: 258,
            column: 8
          },
          end: {
            line: 260,
            column: 9
          }
        }],
        line: 258
      },
      '16': {
        loc: {
          start: {
            line: 302,
            column: 8
          },
          end: {
            line: 304,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 302,
            column: 8
          },
          end: {
            line: 304,
            column: 9
          }
        }, {
          start: {
            line: 302,
            column: 8
          },
          end: {
            line: 304,
            column: 9
          }
        }],
        line: 302
      },
      '17': {
        loc: {
          start: {
            line: 310,
            column: 6
          },
          end: {
            line: 312,
            column: 7
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 310,
            column: 6
          },
          end: {
            line: 312,
            column: 7
          }
        }, {
          start: {
            line: 310,
            column: 6
          },
          end: {
            line: 312,
            column: 7
          }
        }],
        line: 310
      },
      '18': {
        loc: {
          start: {
            line: 367,
            column: 25
          },
          end: {
            line: 367,
            column: 51
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 367,
            column: 25
          },
          end: {
            line: 367,
            column: 43
          }
        }, {
          start: {
            line: 367,
            column: 47
          },
          end: {
            line: 367,
            column: 51
          }
        }],
        line: 367
      },
      '19': {
        loc: {
          start: {
            line: 370,
            column: 8
          },
          end: {
            line: 387,
            column: 9
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 370,
            column: 8
          },
          end: {
            line: 387,
            column: 9
          }
        }, {
          start: {
            line: 370,
            column: 8
          },
          end: {
            line: 387,
            column: 9
          }
        }],
        line: 370
      },
      '20': {
        loc: {
          start: {
            line: 371,
            column: 22
          },
          end: {
            line: 371,
            column: 61
          }
        },
        type: 'binary-expr',
        locations: [{
          start: {
            line: 371,
            column: 22
          },
          end: {
            line: 371,
            column: 56
          }
        }, {
          start: {
            line: 371,
            column: 60
          },
          end: {
            line: 371,
            column: 61
          }
        }],
        line: 371
      },
      '21': {
        loc: {
          start: {
            line: 372,
            column: 10
          },
          end: {
            line: 386,
            column: 11
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 372,
            column: 10
          },
          end: {
            line: 386,
            column: 11
          }
        }, {
          start: {
            line: 372,
            column: 10
          },
          end: {
            line: 386,
            column: 11
          }
        }],
        line: 372
      },
      '22': {
        loc: {
          start: {
            line: 377,
            column: 12
          },
          end: {
            line: 382,
            column: 13
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 377,
            column: 12
          },
          end: {
            line: 382,
            column: 13
          }
        }, {
          start: {
            line: 377,
            column: 12
          },
          end: {
            line: 382,
            column: 13
          }
        }],
        line: 377
      },
      '23': {
        loc: {
          start: {
            line: 409,
            column: 2
          },
          end: {
            line: 412,
            column: 3
          }
        },
        type: 'if',
        locations: [{
          start: {
            line: 409,
            column: 2
          },
          end: {
            line: 412,
            column: 3
          }
        }, {
          start: {
            line: 409,
            column: 2
          },
          end: {
            line: 412,
            column: 3
          }
        }],
        line: 409
      }
    },
    s: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0,
      '32': 0,
      '33': 0,
      '34': 0,
      '35': 0,
      '36': 0,
      '37': 0,
      '38': 0,
      '39': 0,
      '40': 0,
      '41': 0,
      '42': 0,
      '43': 0,
      '44': 0,
      '45': 0,
      '46': 0,
      '47': 0,
      '48': 0,
      '49': 0,
      '50': 0,
      '51': 0,
      '52': 0,
      '53': 0,
      '54': 0,
      '55': 0,
      '56': 0,
      '57': 0,
      '58': 0,
      '59': 0,
      '60': 0,
      '61': 0,
      '62': 0,
      '63': 0,
      '64': 0,
      '65': 0,
      '66': 0,
      '67': 0,
      '68': 0,
      '69': 0,
      '70': 0,
      '71': 0,
      '72': 0,
      '73': 0,
      '74': 0,
      '75': 0,
      '76': 0,
      '77': 0,
      '78': 0,
      '79': 0,
      '80': 0,
      '81': 0,
      '82': 0,
      '83': 0,
      '84': 0,
      '85': 0,
      '86': 0,
      '87': 0,
      '88': 0,
      '89': 0,
      '90': 0,
      '91': 0,
      '92': 0,
      '93': 0,
      '94': 0,
      '95': 0,
      '96': 0,
      '97': 0,
      '98': 0,
      '99': 0,
      '100': 0,
      '101': 0,
      '102': 0,
      '103': 0,
      '104': 0,
      '105': 0
    },
    f: {
      '0': 0,
      '1': 0,
      '2': 0,
      '3': 0,
      '4': 0,
      '5': 0,
      '6': 0,
      '7': 0,
      '8': 0,
      '9': 0,
      '10': 0,
      '11': 0,
      '12': 0,
      '13': 0,
      '14': 0,
      '15': 0,
      '16': 0,
      '17': 0,
      '18': 0,
      '19': 0,
      '20': 0,
      '21': 0,
      '22': 0,
      '23': 0,
      '24': 0,
      '25': 0,
      '26': 0,
      '27': 0,
      '28': 0,
      '29': 0,
      '30': 0,
      '31': 0
    },
    b: {
      '0': [0, 0],
      '1': [0, 0],
      '2': [0, 0],
      '3': [0, 0],
      '4': [0, 0],
      '5': [0, 0],
      '6': [0, 0, 0],
      '7': [0, 0],
      '8': [0, 0],
      '9': [0, 0],
      '10': [0, 0, 0],
      '11': [0, 0],
      '12': [0, 0],
      '13': [0, 0],
      '14': [0, 0],
      '15': [0, 0],
      '16': [0, 0],
      '17': [0, 0],
      '18': [0, 0],
      '19': [0, 0],
      '20': [0, 0],
      '21': [0, 0],
      '22': [0, 0],
      '23': [0, 0]
    },
    _coverageSchema: '332fd63041d2c1bcb487cc26dd0d5f7d97098a6c'
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

++cov_23osts6k1z.s[0];
angular.module('app', ['ui.router', 'ngMaterial', 'ngAnimate', 'ngSanitize', 'ngMaterial', 'ngNotify', 'LocalStorageModule', 'com.2fdevs.videogular', 'com.2fdevs.videogular.plugins.controls', 'com.2fdevs.videogular.plugins.overlayplay', 'angularjs-crypto']
// .value('apiOpen', 'http://localhost:6600/rest/open/')
// .value('apiSec', 'http://localhost:6600/rest/secure/')
// .value('apiOpen', 'http://phongthuy19.vn/api/rest/open/')
// .value('apiSec', 'http://phongthuy19.vn/api/rest/secure/')
).value('myVars', {
  msisdn: null,
  checkMember: 0,
  login: 0,
  packageid: null
}).filter('prettyJSON', function () {
  ++cov_23osts6k1z.f[0];

  function prettyPrintJson(json) {
    ++cov_23osts6k1z.f[1];
    ++cov_23osts6k1z.s[1];

    return JSON ? (++cov_23osts6k1z.b[0][0], JSON.stringify(json, null, '  ')) : (++cov_23osts6k1z.b[0][1], 'your browser doesnt support JSON so cant pretty print');
  }
  ++cov_23osts6k1z.s[2];
  return prettyPrintJson;
}).filter('unsafe', function ($sce) {
  ++cov_23osts6k1z.f[2];
  ++cov_23osts6k1z.s[3];
  return $sce.trustAsHtml;
}).directive('wdcBirthmonth', function () {
  ++cov_23osts6k1z.f[3];
  ++cov_23osts6k1z.s[4];

  return {
    restrict: 'E',
    scope: {
      ngModel: '='
    },
    template: '<select id={{ngName}} name="{{ngName}}" ng-model="ngModel" ng-options="o.name for o in months track by o.value" class="{{ngCss}}"></select> ',
    controller: function controller($scope) {
      ++cov_23osts6k1z.f[4];
      ++cov_23osts6k1z.s[5];

      return $scope.months = [{ name: 'tháng 01', value: 1 }, { name: 'tháng 02', value: 2 }, { name: 'tháng 03', value: 3 }, { name: 'tháng 04', value: 4 }, { name: 'tháng 05', value: 5 }, { name: 'tháng 06', value: 6 }, { name: 'tháng 07', value: 7 }, { name: 'tháng 08', value: 8 }, { name: 'tháng 09', value: 9 }, { name: 'tháng 10', value: 10 }, { name: 'tháng 11', value: 11 }, { name: 'tháng 12', value: 12 }];
    },
    link: function link(scope, element, attrs, modelCtrl) {
      ++cov_23osts6k1z.f[5];
      ++cov_23osts6k1z.s[6];

      scope.ngName = attrs.ngName;
      ++cov_23osts6k1z.s[7];
      scope.ngCss = attrs.ngCss;
      ++cov_23osts6k1z.s[8];
      if (typeof scope.ngModel === 'undefined') {
        ++cov_23osts6k1z.b[1][0];
        ++cov_23osts6k1z.s[9];

        return scope.ngModel = 1;
      } else {
        ++cov_23osts6k1z.b[1][1];
      }
    }
  };
}).directive('wdcBirthday', function () {
  ++cov_23osts6k1z.f[6];
  ++cov_23osts6k1z.s[10];

  return {
    restrict: 'E',
    scope: {
      ngModel: '='
    },
    template: '<select id={{ngName}} name="{{ngName}}" ng-model="ngModel" ng-options="d.name for d in days track by d.value" class="{{ngCss}}"></select> ',
    controller: function controller($scope) {
      ++cov_23osts6k1z.f[7];
      ++cov_23osts6k1z.s[11];

      return $scope.days = [{ name: 'ngày 01', value: 1 }, { name: 'ngày 02', value: 2 }, { name: 'ngày 03', value: 3 }, { name: 'ngày 04', value: 4 }, { name: 'ngày 05', value: 5 }, { name: 'ngày 06', value: 6 }, { name: 'ngày 07', value: 7 }, { name: 'ngày 08', value: 8 }, { name: 'ngày 09', value: 9 }, { name: 'ngày 10', value: 10 }, { name: 'ngày 11', value: 11 }, { name: 'ngày 12', value: 12 }, { name: 'ngày 13', value: 13 }, { name: 'ngày 14', value: 14 }, { name: 'ngày 15', value: 15 }, { name: 'ngày 16', value: 16 }, { name: 'ngày 17', value: 17 }, { name: 'ngày 18', value: 18 }, { name: 'ngày 19', value: 19 }, { name: 'ngày 20', value: 20 }, { name: 'ngày 21', value: 21 }, { name: 'ngày 22', value: 22 }, { name: 'ngày 23', value: 23 }, { name: 'ngày 24', value: 24 }, { name: 'ngày 25', value: 25 }, { name: 'ngày 26', value: 26 }, { name: 'ngày 27', value: 27 }, { name: 'ngày 28', value: 28 }, { name: 'ngày 29', value: 29 }, { name: 'ngày 30', value: 30 }, { name: 'ngày 31', value: 31 }];
    },
    link: function link(scope, element, attrs, modelCtrl) {
      ++cov_23osts6k1z.f[8];
      ++cov_23osts6k1z.s[12];

      scope.ngName = attrs.ngName;
      ++cov_23osts6k1z.s[13];
      scope.ngCss = attrs.ngCss;
      ++cov_23osts6k1z.s[14];
      if (typeof scope.ngModel === 'undefined') {
        ++cov_23osts6k1z.b[2][0];
        ++cov_23osts6k1z.s[15];

        return scope.ngModel = 1;
      } else {
        ++cov_23osts6k1z.b[2][1];
      }
    }
  };
}).directive('wdcBirthyear', function () {
  ++cov_23osts6k1z.f[9];
  ++cov_23osts6k1z.s[16];

  return {
    restrict: 'E',
    require: '?ngModel',
    scope: {
      ngModel: '='
    },
    template: '<input id={{ngName}} name="{{ngName}}" ng-model="ngModel" class="{{ngCss}}" placeholder="{{ngPlaceholder}}" />',
    link: function link($scope, element, attrs, ngModel) {
      ++cov_23osts6k1z.f[10];
      ++cov_23osts6k1z.s[17];

      $scope.ngName = attrs.ngName;
      ++cov_23osts6k1z.s[18];
      $scope.ngCss = attrs.ngCss;
      ++cov_23osts6k1z.s[19];
      $scope.ngPlaceholder = attrs.ngPlaceholder;

      ++cov_23osts6k1z.s[20];
      $scope.$watch('ngModel', function (newValue, oldValue) {
        ++cov_23osts6k1z.f[11];
        ++cov_23osts6k1z.s[21];

        if (String(newValue).indexOf(',') != -1) {
            ++cov_23osts6k1z.b[3][0];
            ++cov_23osts6k1z.s[22];

            $scope.ngModel = String(newValue).replace(',', '.');
          } else {
          ++cov_23osts6k1z.b[3][1];

          var index_dot,
              arr = (++cov_23osts6k1z.s[23], String(newValue).split(""));
          ++cov_23osts6k1z.s[24];
          if (arr.length === 0) {
              ++cov_23osts6k1z.b[4][0];
              ++cov_23osts6k1z.s[25];
              return;
            } else {
            ++cov_23osts6k1z.b[4][1];
          }++cov_23osts6k1z.s[26];
          if ((++cov_23osts6k1z.b[6][0], arr.length === 1) && ((++cov_23osts6k1z.b[6][1], arr[0] == '-') || (++cov_23osts6k1z.b[6][2], arr[0] === '.'))) {
              ++cov_23osts6k1z.b[5][0];
              ++cov_23osts6k1z.s[27];
              return;
            } else {
            ++cov_23osts6k1z.b[5][1];
          }++cov_23osts6k1z.s[28];
          if ((++cov_23osts6k1z.b[8][0], arr.length === 2) && (++cov_23osts6k1z.b[8][1], newValue === '-.')) {
              ++cov_23osts6k1z.b[7][0];
              ++cov_23osts6k1z.s[29];
              return;
            } else {
            ++cov_23osts6k1z.b[7][1];
          }++cov_23osts6k1z.s[30];
          if ((++cov_23osts6k1z.b[10][0], isNaN(newValue)) || (++cov_23osts6k1z.b[10][1], (index_dot = String(newValue).indexOf('.')) != -1) && (++cov_23osts6k1z.b[10][2], String(newValue).length - index_dot > 3)) {
            ++cov_23osts6k1z.b[9][0];
            ++cov_23osts6k1z.s[31];

            $scope.ngModel = oldValue;
          } else {
            ++cov_23osts6k1z.b[9][1];
          }
          var tmp = (++cov_23osts6k1z.s[32], parseFloat($scope.ngModel));
          ++cov_23osts6k1z.s[33];
          if ((++cov_23osts6k1z.b[12][0], tmp < 0) || (++cov_23osts6k1z.b[12][1], tmp > 2999)) {
            ++cov_23osts6k1z.b[11][0];
            ++cov_23osts6k1z.s[34];

            $scope.ngModel = oldValue;
          } else {
            ++cov_23osts6k1z.b[11][1];
          }
        }
      });
    }
  };
}).directive('wdcSex', function () {
  ++cov_23osts6k1z.f[12];
  ++cov_23osts6k1z.s[35];

  return {
    restrict: 'E',
    scope: {
      ngModel: '='
    },
    template: '<select id={{ngName}} name="{{ngName}}" ng-model="ngModel" ng-options="o.name for o in gens track by o.value" class="{{ngCss}}"></select> ',
    controller: function controller($scope) {
      ++cov_23osts6k1z.f[13];
      ++cov_23osts6k1z.s[36];

      return $scope.gens = [{ name: 'Nam', value: 1 }, { name: 'Nữ', value: 2 }];
    },
    link: function link(scope, element, attrs, modelCtrl) {
      ++cov_23osts6k1z.f[14];
      ++cov_23osts6k1z.s[37];

      scope.ngName = attrs.ngName;
      ++cov_23osts6k1z.s[38];
      scope.ngCss = attrs.ngCss;
      ++cov_23osts6k1z.s[39];
      if (typeof scope.ngModel === 'undefined') {
        ++cov_23osts6k1z.b[13][0];
        ++cov_23osts6k1z.s[40];

        return scope.ngModel = 1;
      } else {
        ++cov_23osts6k1z.b[13][1];
      }
    }
  };
}).directive('wdcCalendar', function () {
  ++cov_23osts6k1z.f[15];
  ++cov_23osts6k1z.s[41];

  return {
    restrict: 'E',
    scope: {
      ngModel: '='
    },
    template: '<select id={{ngName}} name="{{ngName}}" ng-model="ngModel" ng-options="o.name for o in calendar track by o.value" class="{{ngCss}}"></select> ',
    controller: function controller($scope) {
      ++cov_23osts6k1z.f[16];
      ++cov_23osts6k1z.s[42];

      return $scope.calendar = [{ name: 'Dương lịch', value: 'True' }, { name: 'Âm lịch', value: 'False' }];
    },
    link: function link(scope, element, attrs, modelCtrl) {
      ++cov_23osts6k1z.f[17];
      ++cov_23osts6k1z.s[43];

      scope.ngName = attrs.ngName;
      ++cov_23osts6k1z.s[44];
      scope.ngCss = attrs.ngCss;
      ++cov_23osts6k1z.s[45];
      if (typeof scope.ngModel === 'undefined') {
        ++cov_23osts6k1z.b[14][0];
        ++cov_23osts6k1z.s[46];

        return scope.ngModel = 1;
      } else {
        ++cov_23osts6k1z.b[14][1];
      }
    }
  };
}).directive('wdcMinute', function () {
  ++cov_23osts6k1z.f[18];
  ++cov_23osts6k1z.s[47];

  return {
    restrict: 'E',
    scope: {
      ngModel: '='
    },
    template: '<select id={{ngName}} name="{{ngName}}" ng-model="ngModel" ng-options="o.name for o in minutes track by o.value" class="{{ngCss}}"></select> ',
    controller: function controller($scope) {
      ++cov_23osts6k1z.f[19];
      ++cov_23osts6k1z.s[48];

      return $scope.minutes = [{ name: '00 phút', value: 0 }, { name: '01 phút', value: 1 }, { name: '02 phút', value: 2 }, { name: '03 phút', value: 3 }, { name: '04 phút', value: 4 }, { name: '05 phút', value: 5 }, { name: '06 phút', value: 6 }, { name: '07 phút', value: 7 }, { name: '08 phút', value: 8 }, { name: '09 phút', value: 9 }, { name: '10 phút', value: 10 }, { name: '11 phút', value: 11 }, { name: '12 phút', value: 12 }, { name: '13 phút', value: 13 }, { name: '14 phút', value: 14 }, { name: '15 phút', value: 15 }, { name: '16 phút', value: 16 }, { name: '17 phút', value: 17 }, { name: '18 phút', value: 18 }, { name: '19 phút', value: 19 }, { name: '20 phút', value: 20 }, { name: '21 phút', value: 21 }, { name: '22 phút', value: 22 }, { name: '23 phút', value: 23 }, { name: '24 phút', value: 24 }, { name: '25 phút', value: 25 }, { name: '26 phút', value: 26 }, { name: '27 phút', value: 27 }, { name: '28 phút', value: 28 }, { name: '29 phút', value: 29 }, { name: '30 phút', value: 30 }, { name: '31 phút', value: 31 }, { name: '32 phút', value: 32 }, { name: '33 phút', value: 33 }, { name: '34 phút', value: 34 }, { name: '35 phút', value: 35 }, { name: '36 phút', value: 36 }, { name: '37 phút', value: 37 }, { name: '38 phút', value: 38 }, { name: '39 phút', value: 39 }, { name: '40 phút', value: 40 }, { name: '41 phút', value: 41 }, { name: '42 phút', value: 42 }, { name: '43 phút', value: 43 }, { name: '44 phút', value: 44 }, { name: '45 phút', value: 45 }, { name: '46 phút', value: 46 }, { name: '47 phút', value: 47 }, { name: '48 phút', value: 48 }, { name: '49 phút', value: 49 }, { name: '50 phút', value: 50 }, { name: '51 phút', value: 51 }, { name: '52 phút', value: 52 }, { name: '53 phút', value: 53 }, { name: '54 phút', value: 54 }, { name: '55 phút', value: 55 }, { name: '56 phút', value: 56 }, { name: '57 phút', value: 57 }, { name: '58 phút', value: 58 }, { name: '59 phút', value: 59 }];
    },
    link: function link(scope, element, attrs, modelCtrl) {
      ++cov_23osts6k1z.f[20];
      ++cov_23osts6k1z.s[49];

      scope.ngName = attrs.ngName;
      ++cov_23osts6k1z.s[50];
      scope.ngCss = attrs.ngCss;
      ++cov_23osts6k1z.s[51];
      if (typeof scope.ngModel === 'undefined') {
        ++cov_23osts6k1z.b[15][0];
        ++cov_23osts6k1z.s[52];

        return scope.ngModel = 1;
      } else {
        ++cov_23osts6k1z.b[15][1];
      }
    }
  };
}).directive('wdcHour', function () {
  ++cov_23osts6k1z.f[21];
  ++cov_23osts6k1z.s[53];

  return {
    restrict: 'E',
    scope: {
      ngModel: '='
    },
    template: '<select id={{ngName}} name="{{ngName}}" ng-model="ngModel" ng-options="o.name for o in hours track by o.value" class="{{ngCss}}"></select> ',
    controller: function controller($scope) {
      ++cov_23osts6k1z.f[22];
      ++cov_23osts6k1z.s[54];

      return $scope.hours = [{ name: '00 giờ', value: 0 }, { name: '01 giờ', value: 1 }, { name: '02 giờ', value: 2 }, { name: '03 giờ', value: 3 }, { name: '04 giờ', value: 4 }, { name: '05 giờ', value: 5 }, { name: '06 giờ', value: 6 }, { name: '07 giờ', value: 7 }, { name: '08 giờ', value: 8 }, { name: '09 giờ', value: 9 }, { name: '10 giờ', value: 10 }, { name: '11 giờ', value: 11 }, { name: '12 giờ', value: 12 }, { name: '13 giờ', value: 13 }, { name: '14 giờ', value: 14 }, { name: '15 giờ', value: 15 }, { name: '16 giờ', value: 16 }, { name: '17 giờ', value: 17 }, { name: '18 giờ', value: 18 }, { name: '19 giờ', value: 19 }, { name: '20 giờ', value: 20 }, { name: '21 giờ', value: 21 }, { name: '22 giờ', value: 22 }, { name: '23 giờ', value: 23 }];
    },
    link: function link(scope, element, attrs, modelCtrl) {
      ++cov_23osts6k1z.f[23];
      ++cov_23osts6k1z.s[55];

      scope.ngName = attrs.ngName;
      ++cov_23osts6k1z.s[56];
      scope.ngCss = attrs.ngCss;
      ++cov_23osts6k1z.s[57];
      if (typeof scope.ngModel === 'undefined') {
        ++cov_23osts6k1z.b[16][0];
        ++cov_23osts6k1z.s[58];

        return scope.ngModel = 1;
      } else {
        ++cov_23osts6k1z.b[16][1];
      }
    }
  };
}).filter('urlEncode', [function () {
  ++cov_23osts6k1z.f[24];
  ++cov_23osts6k1z.s[59];

  return function (input) {
    ++cov_23osts6k1z.f[25];
    ++cov_23osts6k1z.s[60];

    if (typeof input == "undefined") {
      ++cov_23osts6k1z.b[17][0];
      ++cov_23osts6k1z.s[61];

      return;
    } else {
      ++cov_23osts6k1z.b[17][1];
    }
    var str;
    ++cov_23osts6k1z.s[62];
    str = input;
    ++cov_23osts6k1z.s[63];
    str = str.toLowerCase();
    ++cov_23osts6k1z.s[64];
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
    ++cov_23osts6k1z.s[65];
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
    ++cov_23osts6k1z.s[66];
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
    ++cov_23osts6k1z.s[67];
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
    ++cov_23osts6k1z.s[68];
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
    ++cov_23osts6k1z.s[69];
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
    ++cov_23osts6k1z.s[70];
    str = str.replace(/đ/g, "d");
    //str= str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'| |\"|\&|\#|\[|\]|~|$|_/g,"-");
    /* tìm và thay thế các kí tự đặc biệt trong chuỗi sang kí tự - */
    //str= str.replace(/-+-/g,"-"); //thay thế 2- thành 1-
    ++cov_23osts6k1z.s[71];
    str = str.replace(/[\&]/g, '-and-').replace(/[^a-zA-Z0-9._-]/g, '-').replace(/[-]+/g, '-').replace(/-$/, '');
    ++cov_23osts6k1z.s[72];
    return str;
    //cắt bỏ ký tự - ở đầu và cuối chuỗi
    // eval(input).value = str.toUpperCase();
    // var i=0,uni1,arr1,ret;
    // var newclean=input;
    // uni1 = 'à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ|À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ|A';
    // arr1 = uni1.split('|');
    // for (i=0; i<uni1.length; i++) newclean = newclean.replace(uni1[i],'a');
    //
    // uni1 = 'è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ|È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ|E';
    // arr1 = uni1.split('|');
    // for (i=0; i<uni1.length; i++) newclean = newclean.replace(uni1[i],'e');
    //
    // uni1 = 'ì|í|ị|ỉ|ĩ|Ì|Í|Ị|Ỉ|Ĩ|I';
    // arr1 = uni1.split('|');
    // for (i=0; i<uni1.length; i++) newclean = newclean.replace(uni1[i],'i');
    //
    // uni1 = 'ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ|Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ|O';
    // arr1 = uni1.split('|');
    // for (i=0; i<uni1.length; i++) newclean = newclean.replace(uni1[i],'o');
    //
    // uni1 = 'ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ|Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ|U';
    // arr1 = uni1.split('|');
    // for (i=0; i<uni1.length; i++) newclean = newclean.replace(uni1[i],'u');
    //
    // uni1 = 'ỳ|ý|ỵ|ỷ|ỹ|Ỳ|Ý|Ỵ|Ỷ|Ỹ|Y';
    // arr1 = uni1.split('|');
    // for (i=0; i<uni1.length; i++) newclean = newclean.replace(uni1[i],'y');
    //
    // uni1 = 'd|Đ|D';
    // arr1 = uni1.split('|');
    // for (i=0; i<uni1.length; i++) newclean = newclean.replace(uni1[i],'d');
    //
    // newclean = newclean.toLowerCase()
    // ret = newclean.replace(/[\&]/g, '-and-').replace(/[^a-zA-Z0-9._-]/g, '-').replace(/[-]+/g, '-').replace(/-$/, '');
    //
    // return ret;
  };
}]).factory('PageViews', ['localStorageService', '$filter', function (localStorageService, $filter) {
  ++cov_23osts6k1z.f[26];
  ++cov_23osts6k1z.s[73];

  localStorage.views = (++cov_23osts6k1z.b[18][0], localStorage.views) || (++cov_23osts6k1z.b[18][1], '{}');
  ++cov_23osts6k1z.s[74];
  return {
    add: function add(stateName) {
      ++cov_23osts6k1z.s[75];

      if (localStorageService.isSupported) {
        ++cov_23osts6k1z.b[19][0];

        var views = (++cov_23osts6k1z.s[76], (++cov_23osts6k1z.b[20][0], localStorageService.get(stateName)) || (++cov_23osts6k1z.b[20][1], 0));
        ++cov_23osts6k1z.s[77];
        if (localStorageService.get('expire')) {
          ++cov_23osts6k1z.b[21][0];

          var dt = (++cov_23osts6k1z.s[78], localStorageService.get('expire'));
          var check1 = (++cov_23osts6k1z.s[79], moment(localStorageService.get('expire')).isSame(moment().format('YYYYMMDD')));

          var check = (++cov_23osts6k1z.s[80], moment(localStorageService.get('expire'), 'YYYYMMDD').fromNow());
          ++cov_23osts6k1z.s[81];
          if (check1) {
            ++cov_23osts6k1z.b[22][0];
            ++cov_23osts6k1z.s[82];

            localStorageService.set(stateName, ++views);
          } else {
            ++cov_23osts6k1z.b[22][1];
            ++cov_23osts6k1z.s[83];

            localStorageService.set(stateName, 1);
            ++cov_23osts6k1z.s[84];
            localStorageService.set('expire', $filter('date')(new Date(), 'yyyyMMdd'));
          }
        } else {
          ++cov_23osts6k1z.b[21][1];
          ++cov_23osts6k1z.s[85];

          localStorageService.set(stateName, ++views);
          ++cov_23osts6k1z.s[86];
          localStorageService.set('expire', $filter('date')(new Date(), 'yyyyMMdd'));
        }
      } else {
        ++cov_23osts6k1z.b[19][1];
      }
    },
    get: function get(stateName) {
      ++cov_23osts6k1z.s[87];

      return localStorageService.get(stateName);
    }
  };
}]);
var scrHeight = (++cov_23osts6k1z.s[88], $(".cbp-fbscroller section").height());
++cov_23osts6k1z.s[89];
$('body').on('click', 'span.mnBtnHide', function () {
  ++cov_23osts6k1z.f[27];
  ++cov_23osts6k1z.s[90];

  $(this).parent().animate({ left: -100 + '%' }).hide(500);
});
++cov_23osts6k1z.s[91];
$('body').on('click', '.showMnBtn, span.mnBtnShow', function () {
  ++cov_23osts6k1z.f[28];
  ++cov_23osts6k1z.s[92];

  $('.wrHideMenu').show().animate({ left: 0 });
});
++cov_23osts6k1z.s[93];
$('body').on('click', '.hidMenu ul.menuList li a', function () {
  ++cov_23osts6k1z.f[29];
  ++cov_23osts6k1z.s[94];

  $('.hidMenu ul.menuList li ul').hide(0);
  ++cov_23osts6k1z.s[95];
  $('.hidMenu ul.menuList li a').removeClass('active');
  ++cov_23osts6k1z.s[96];
  $('.hidMenu ul.menuList li a img.arDownIcon').removeClass('active');
  ++cov_23osts6k1z.s[97];
  $(this).children('img.arDownIcon').addClass('active');
  ++cov_23osts6k1z.s[98];
  $(this).addClass('active');
  ++cov_23osts6k1z.s[99];
  $(this).next('ul').show(0);
  ++cov_23osts6k1z.s[100];
  if ($(this).attr("href") !== 'javascript:;') {
    ++cov_23osts6k1z.b[23][0];
    ++cov_23osts6k1z.s[101];

    $('.wrHideMenu').animate({ left: -100 + '%' }).hide(500);
    //menuClick($(this).attr("href"));
  } else {
    ++cov_23osts6k1z.b[23][1];
  }
});
++cov_23osts6k1z.s[102];
$('body').on('click', 'span.mnBtnHide', function () {
  ++cov_23osts6k1z.f[30];
  ++cov_23osts6k1z.s[103];

  $(this).parent().animate({ left: -100 + '%' }).hide(500);
});
++cov_23osts6k1z.s[104];
$('body').on('click', '.showMnBtn, span.mnBtnShow', function () {
  ++cov_23osts6k1z.f[31];
  ++cov_23osts6k1z.s[105];

  $('.wrHideMenu').show().animate({ left: 0 });
});